module.exports = __webpack_public_path__ + "static/media/statistics.f0ef8dd9.png";